// FETCH ALL IRONING_PACKING INWARD
export const FETCH_IRONING_PACKING_INWARD_MASTER_REQUEST_DK = 'FETCH_IRONING_PACKING_INWARD_MASTER_REQUEST_DK';
export const FETCH_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK = 'FETCH_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_IRONING_PACKING_INWARD_MASTER_FAILURE_DK = 'FETCH_IRONING_PACKING_INWARD_MASTER_FAILURE_DK';

// FETCH ALL IRONING_PACKING INWARD
export const FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK = 'FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK';
export const FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK = 'FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK';
export const FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK = 'FETCH_IRONING_PACKING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK';

// CREATE IRONING_PACKING INWARD
export const CREATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK = 'CREATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK';
export const CREATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK = 'CREATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK';
export const CREATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK = 'CREATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK';

// CREATE IRONING_PACKING INWARD
export const CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_REQUEST_DK = 'CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_REQUEST_DK';
export const CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK = 'CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK';
export const CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_FAILURE_DK = 'CREATE_IRONING_PACKING_INWARD_EDIT_QTY_MASTER_FAILURE_DK';

// UPDATE IRONING_PACKING INWARD
export const UPDATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK = 'UPDATE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK';
export const UPDATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK = 'UPDATE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK';
export const UPDATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK = 'UPDATE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF IRONING_PACKING INWARD
export const FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK = 'FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK';
export const FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK = 'FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK = 'FETCH_SINGLE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK';

// DELETE IRONING_PACKING INWARD
export const DELETE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK = 'DELETE_IRONING_PACKING_INWARD_MASTER_REQUEST_DK';
export const DELETE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK = 'DELETE_IRONING_PACKING_INWARD_MASTER_SUCCESS_DK';
export const DELETE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK = 'DELETE_IRONING_PACKING_INWARD_MASTER_FAILURE_DK';

export const FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_IRONING_PACKING_PO_IN_INWARD_FAILURE_DK';

export const RESET_IRONING_PACKING_INWARD_MASTER_INFO_DK = 'RESET_IRONING_PACKING_INWARD_MASTER_INFO_DK';

export const CREATE_IRONING_PACKING_INWARD_MASTER_FORM_DK = 'CREATE_IRONING_PACKING_INWARD_MASTER_FORM_DK';

export const UPDATE_IRONING_PACKING_INWARD_MASTER_FORM_DK = 'UPDATE_IRONING_PACKING_INWARD_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_IRONING_PACKING_INWARD_DETAILS_DK = 'NAVIGATE_IRONING_PACKING_INWARD_DETAILS_DK';

// NAVIGATE TO IRONING_PACKING INWARD COMPONENT
export const NAVIGATE_IRONING_PACKING_INWARD_MASTER_DK = 'NAVIGATE_IRONING_PACKING_INWARD_MASTER_DK';

export const RESET_FORM_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK';

export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK =
    'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_IRONING_PACKING_INWARD_ID_DK';

export const SET_ACTIVE_KEY_IRONING_PACKING_INWARD_DK = 'SET_ACTIVE_KEY_IRONING_PACKING_INWARD_DK';


export const SET_PENDING_GRID_NAME_IRONING_PACKING_INWARD_DK = 'SET_PENDING_GRID_NAME_IRONING_PACKING_INWARD_DK';
export const SET_UNIT_NAME_IRONING_PACKING_INWARD_DK = 'SET_UNIT_NAME_IRONING_PACKING_INWARD_DK';


export const FETCH_COMPLETE_IRONING_PACKING_INWARD_REQUEST_DK = 'FETCH_COMPLETE_IRONING_PACKING_INWARD_REQUEST_DK';
export const FETCH_COMPLETE_IRONING_PACKING_INWARD_SUCCESS_DK = 'FETCH_COMPLETE_IRONING_PACKING_INWARD_SUCCESS_DK';
export const FETCH_COMPLETE_IRONING_PACKING_INWARD_FAILURE_DK = 'FETCH_COMPLETE_IRONING_PACKING_INWARD_FAILURE_DK';


export const FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK';
export const FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK = 'FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK';